<template>
    <div class="col-sm-5">
        <div class="panel panel-default" v-if="uzivatel">
            <div class="panel-heading">
                <div v-if="uzivatel.length<8"><strong>{{ uzivatel }}</strong></div>
                <div v-if="uzivatel.length>=8"><strong>{{ uzivatel.substring(0,8)+".." }}</strong></div>
            </div>

            <div class="panel-body">  <star-rating :rating="rating" :read-only="true" :increment="increment"></star-rating> <br>{{ text }}</div>

    
            <!-- /panel-body -->
        </div>
        <!-- /panel panel-default -->
    </div>
    <!-- /col-sm-5 -->
</template>

<script>
import StarRating from "vue-star-rating"
export default {
    components: {
        StarRating
    },
    props: {
        uzivatel: String,
        text: String,
        rating: Number,
        maxLength: Number,
        increment: Number
    }

}
</script>